import { CourseChapter, CourseModuleCards } from "@mikros/library";
import { useEffect, useRef, useState } from "react";
import { SortableItemUIProps } from "@progress/kendo-react-sortable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { Tooltip, Whisper } from "rsuite";
import { Switch } from "@progress/kendo-react-inputs";
import { CardComponent } from "../courseModuleChapters/cardComponent";
import { ViewAssementCard } from "../courseModuleChapters/viewAssessmentCard";
import { useIntl } from "react-intl";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Alert } from "../alert";
import { truncate } from "node:fs";

export interface GeneratedChapterProps extends SortableItemUIProps {
  enableDrag: boolean;
  makeEditable: (chapter: CourseChapter) => void;
  getIndex: (chptId: string) => number;
  cards: CourseModuleCards;
  handleEnableDrag: (drag: boolean) => void;
  handleDuplicateChapter: (chapter: CourseChapter) => void;
  handleDelChapter: (chapter: CourseChapter) => void;
  status?: string;
  courseName?: string;
  courseDescription?: string;
}

export function GeneratedChapter(props: GeneratedChapterProps) {
  const intl = useIntl();
  const tooltip = (
    <Tooltip className="bg-mk-primary-bright text-white">
      <div>{`${intl.formatMessage({
        id: "courses.gneratedChapter.editChapter",
      })}`}</div>
    </Tooltip>
  );

  const delChapter = (
    <Tooltip
      className="bg-mk-primary-bright text-white "
      style={{ zIndex: 99999 }}
    >
      <div>{`${intl.formatMessage({
        id: "courses.gneratedChapter.deleteChapter",
      })}`}</div>
    </Tooltip>
  );

  const dupChapter = (
    <Tooltip className="bg-mk-primary-bright text-white">
      <div>{`${intl.formatMessage({
        id: "courses.gneratedChapter.duplicateChapter",
      })}`}</div>
    </Tooltip>
  );

  const viewChapter = (
    <Tooltip
      className="bg-mk-primary-bright text-white"
      style={{ zIndex: 99999 }}
    >
      <div>{`${intl.formatMessage({
        id: "courses.gneratedChapter.viewChapter",
      })}`}</div>
    </Tooltip>
  );

  const [chaptCards, setChaptCards] = useState<CourseChapter>(props.dataItem);
  const [toggle, setToggle] = useState<boolean>(false);
  const [openSection, setOpenSection] = useState<boolean>(false);

  const [warningDialogue, setWarningDialogue] = useState<boolean>(false);

  const sampleRef = useRef();
  const { isDisabled, isActive, style, attributes, dataItem, forwardRef } =
    props;

  // Helper function to check if any card has dummyTempUrl
  // const hasDummyTempUrl = (chapter: CourseChapter): boolean => {
  //   return (
  //     chapter.cards?.some(
  //       (card) =>
  //         card.cardInfo?.card?.[0]?.url?.includes("dummyTempUrl") ||
  //         card.cardInfo?.card?.[0]?.tempUrl?.includes("dummyTempUrl")
  //     ) || false
  //   );
  // };

  // The reason why "warningDialogue" always logs as false is likely because this console.log is executed on every render,
  // and the value of warningDialogue is only updated asynchronously after setWarningDialogue is called.
  // To observe changes to warningDialogue, use a useEffect hook like this:
  useEffect(() => {
    console.log("warning dialogue value changed:", warningDialogue);
  }, [warningDialogue]);



  const toggleWarningDialogue = () => {
    console.log("inside of toggle of warning dialogue");
    setWarningDialogue(!warningDialogue);
  };

  const getObjectNotFoundUrl = (chapter: CourseChapter): boolean => {
    console.log("inside get object not found url");
    if (!chapter.cards) return false;

    for (const card of chapter.cards) {
      const cardUrl = card.url;
      console.log("Card url value print",cardUrl)

      if (cardUrl === "" || cardUrl?.includes("object not found")) {
        // if (cardUrl?.includes("object not found")) {
        console.log("card url empty or object not found ")
        return true;
      }
    }
    return false;
  };

  // Check if this chapter has dummyTempUrl
  // const hasDummyUrl = hasDummyTempUrl(chaptCards);
  const hasEmptyUrl = getObjectNotFoundUrl(chaptCards);

  console.log("Has empty url in gneratedChapter file",hasEmptyUrl)

  console.log("Course name in generatedChapter:", props.courseName);
  console.log(
    "Course description in generatedChapter:",
    props.courseDescription
  );

  console.log(
    "card data temp url inside generatedChapter for chapter",
    chaptCards.chapterId,
    chaptCards.cards?.[0]?.cardInfo?.card?.[0]?.url,
    "Has dummyTempUrl print pleaseeee:",
    getObjectNotFoundUrl
  );

  return (
    <div
      key={`chapters_${chaptCards.chapterId}`}
      ref={props.enableDrag ? forwardRef : sampleRef}
      {...attributes}
      style={
        props.enableDrag
          ? {
              ...style,
              cursor: "default",
            }
          : {}
      }
      className={`group w-full mb-5 p-3 hover:cursor-default ${
        openSection === true
          ? "rounded-2xl space-y-5 border border-mk-primary-bright pb-5"
          : // : "hover:shadow-xl rounded-full bg-mk-primary-50 "
            "hover:shadow-xl rounded-full bg-mk-primary-20 hover:bg-mk-primary"
      } `}
    >
      <div
        className={`hide-scroll overflow-auto hover:cursor-default w-full h-full flex justify-around items-center px-3`}
      >
        <div className="flex space-x-3 w-[45%] pr-2 justify-start items-center">
          <FontAwesomeIcon
            icon={["far", "fa-arrows-up-down-left-right" as IconName]}
            className={`h-4 w-4 hover:cursor-move text-mk-primary-bright cursor-move ${
              props.status === "PUBLISHED" ? "hidden" : ""
            }
            ${
              openSection === true
                ? "text-mk-primary"
                : "text-mk-primary-bright group-hover:text-white"
            }
            `}
            onMouseEnter={() => {
              props.handleEnableDrag(true);
            }}
          />

          {/* <div className="font-bold text-base 
          group-hover:text-white"
          > */}

          <div
            className={`font-bold text-base text-mk-text-grey ${
              openSection
                ? "text-mk-text-grey"
                : "text-mk-text-grey group-hover:text-white"
            }`}
          >
            {`${intl.formatMessage({
              id: "courses.generatedChapterEdit.chapter",
            })}` + props.getIndex(chaptCards.chapterId)}
          </div>

          <div
            className={`border border-mk-primary-bright bg-mk-primary-50 flex justify-center items-center rounded-lg md:text-sm sm:text-[12px] px-0 ${
              openSection === true ? "" : "group-hover:bg-mk-primary-bright"
            }`}
          >
            <div
              className={`h-full px-2 py-1 font-bold text-sm ${
                openSection
                  ? "text-mk-very-dark-grey"
                  : "text-mk-very-dark-grey group-hover:text-white"
              }`}
            >
              {chaptCards.chapterName}
            </div>
          </div>
          <Whisper
            placement="top"
            controlId="control-id-hover"
            trigger="hover"
            speaker={tooltip}
          >
            <FontAwesomeIcon
              icon={["far", "fa-pen" as IconName]}
              className={` ${
                props.status === "PUBLISHED" ? "hidden" : ""
              } fa-fw w-4 h-4 hover:cursor-pointer  hover:text-mk-primary-bright ${
                openSection === true
                  ? "text-mk-primary"
                  : "text-mk-primary-bright group-hover:text-white"
              }`}
              onClick={() => {
                if (props.courseName === "" || props.courseDescription === "") {
                  console.log(
                    "inside the course name empty of gnerated Chapter"
                  );
                  // The following line sets warningDialogue to true
                  setWarningDialogue(true);
                  return;
                }
                props.makeEditable(chaptCards);
              }}
            />
          </Whisper>
        </div>
        <div className="flex w-[55%] justify-end items-center space-x-5">
          {/* <div className="font-bold group-hover:text-white "> */}

          <div
            className={`h-full px-2 py-1 font-bold text-sm ${
              openSection
                ? "text-mk-text-grey"
                : "text-mk-text-grey group-hover:text-white"
            }`}
          >
            {intl.formatMessage({
              id: "courses.generateChapterEdit.micros",
            })}
          </div>
          <Switch
            onLabel={""}
            offLabel={""}
            onChange={() => setToggle(!toggle)}
            size={"small"}
            trackRounded={"full"}
            thumbRounded={"full"}
            defaultChecked={toggle}
          />
          {/* <div className="font-bold group-hover:text-white"> */}
          <div
            className={`h-full px-2 py-1 font-bold text-sm text-mk-text-grey ${
              !openSection ? "group-hover:text-white" : ""
            }`}
          >
            {intl.formatMessage({
              id: "courses.generateChapterEdit.assessment",
            })}
          </div>
          <div className="flex items-center space-x-1 ">
            {/* <div
              className={`rounded-full  p-1.5  ${
                toggle
                  ? "bg-mk-very-dark-grey group-hover:!bg-white"
                  : "bg-mk-primary-bright group-hover:!bg-white"
              } `}
            /> */}

            <div
              className={`rounded-full p-1.5 ${
                toggle
                  ? openSection
                    ? "bg-mk-very-dark-grey"
                    : "bg-mk-very-dark-grey group-hover:!bg-white"
                  : openSection
                  ? "bg-mk-primary-bright"
                  : "bg-mk-primary-bright group-hover:!bg-white"
              }`}
            ></div>

            {/* <div className="group-hover:text-white"> */}
            <div
              className={`${
                !openSection ? "group-hover:text-white" : ""
              } whitespace-nowrap`}
            >
              {chaptCards.cards.length}
              {intl.formatMessage({
                id: "courses.generateChapterEdit.micros",
              })}
            </div>
          </div>
          <div className="flex items-center space-x-1">
            {/* <div
              className={`rounded-full  p-1.5 ${
                toggle
                  ? "bg-mk-primary-bright group-hover:!bg-white"
                  : "bg-mk-very-dark-grey group-hover:!bg-white"
              }`}
            /> */}

            {/* Warning dialog for missing course name or description */}
            {warningDialogue && (
              <Dialog className="warningDialogue">
                <Alert
                  // description="Please fill in the course name and course description before proceeding to edit the chapter."
                  description={`${intl.formatMessage({
                    id: "courses.gneratedChapter.courseWarningDialogue",
                  })}`}
                  buttonText={`${intl.formatMessage({
                    id: "users.buttonText.Ok",
                  })}`}
                  icon={"warningShape.png"}
                  iconMsg={intl.formatMessage({
                    id: "iconMsgWarning",
                  })}
                  backgroundColor={"mk-orange"}
                  onClick={() => {
                    // toggleWarningDialogue();
                    setWarningDialogue(false);
                  }}
                />
              </Dialog>
            )}

            <div
              className={`rounded-full p-1.5 ${
                toggle
                  ? openSection
                    ? "bg-mk-primary-bright"
                    : "bg-mk-primary-bright group-hover:!bg-white"
                  : openSection
                  ? "bg-mk-very-dark-grey"
                  : "bg-mk-very-dark-grey group-hover:!bg-white"
              }`}
            ></div>

            {/* <div className="group-hover:text-white"> */}
            <div
              className={`${
                !openSection ? "group-hover:text-white" : ""
              } whitespace-nowrap`}
            >
              {chaptCards.questions?.length}
              {intl.formatMessage({
                id: "courses.generateChapterEdit.assessment",
              })}
            </div>
            {/* <FontAwesomeIcon
              icon={["far", "fa-arrows-repeat" as IconName]}
              className={`fa-fw w-5 h-5 rotate-90 group-hover:text-white ${
                props.status === "PUBLISHED" ? "hidden" : ""
              } hover:text-mk-primary-bright hover:cursor-pointer ${
                openSection === true
                  ? "text-mk-primary"
                  : "text-mk-primary-bright"
              }`}
            /> */}

            <div className="mr-1"></div>

            <FontAwesomeIcon
              icon={["far", "fa-arrows-repeat" as IconName]}
              className={`fa-fw w-5 h-5 rotate-90  ${
                props.status === "PUBLISHED" ? "hidden" : ""
              } hover:text-mk-primary-bright hover:cursor-pointer ${
                openSection === true
                  ? "text-mk-primary"
                  : "text-mk-primary-bright group-hover:text-white"
              }`}
            />
          </div>
          <Whisper
            placement="top"
            controlId="control-id-hover"
            trigger="hover"
            speaker={
              hasEmptyUrl ? (
                <Tooltip className="bg-mk-primary-bright text-white">
                  <div>{`${intl.formatMessage({
                    id: "courses.generateChaptersCards.aiVideoGenerationInProgress",
                  })}`}</div>
                </Tooltip>
              ) : (
                delChapter
              )
            }
          >
            <FontAwesomeIcon
              icon={["far", "fa-trash" as IconName]}
              onClick={() => {
                if (!hasEmptyUrl) {
                  props.handleDelChapter(chaptCards);
                }
              }}
              className={`fa-fw w-4 h-4 ${
                props.status === "PUBLISHED" ? "hidden" : ""
              } ${
                hasEmptyUrl
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:cursor-pointer hover:text-mk-primary-bright"
              } ${
                openSection === true
                  ? "text-mk-primary"
                  : "text-mk-primary-bright group-hover:text-white"
              }`}
            />
          </Whisper>

          <Whisper
            placement="top"
            controlId="control-id-hover"
            trigger="hover"
            // speaker={dupChapter}
            speaker={
              hasEmptyUrl ? (
                <Tooltip className="bg-mk-primary-bright text-white">
                  <div>
                    {`${intl.formatMessage({
                      id: "courses.generateChaptersCards.aiVideoGenerationInProgress",
                    })}`}
                  </div>
                </Tooltip>
              ) : (
                dupChapter
              )
            }
          >
            <FontAwesomeIcon
              icon={["fas", "fa-copy" as IconName]}
              onClick={() => {
                // props.handleDuplicateChapter(chaptCards);
                if (!hasEmptyUrl) {
                  props.handleDuplicateChapter(chaptCards);
                }
              }}
              // className={`fa-fw w-4 h-4 hover:cursor-pointer ${
              //   props.status === "PUBLISHED" ? "hidden" : ""
              // } hover:text-mk-primary-bright  ${
              //   (openSection === true) === true
              //     ? "text-mk-primary"
              //     : "text-mk-primary-bright group-hover:text-white"
              // }`}

              className={`fa-fw w-4 h-4 ${
                props.status === "PUBLISHED" ? "hidden" : ""
              } ${
                hasEmptyUrl
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:cursor-pointer hover:text-mk-primary-bright"
              } ${
                openSection === true
                  ? "text-mk-primary"
                  : "text-mk-primary-bright group-hover:text-white"
              }`}
            />
          </Whisper>
          <Whisper
            placement="top"
            controlId="control-id-hover"
            trigger="hover"
            speaker={viewChapter}
          >
            <FontAwesomeIcon
              icon={["fas", "fa-play" as IconName]}
              //   className={`h-4 w-4 ml-3 hover:cursor-pointer text-mk-primary-bright ${
              //     openSection === true ? "rotate-90" : ""
              //   }`
              // }

              className={`h-4 w-4 ml-3 hover:cursor-pointer hover:text-mk-primary-bright ${
                openSection
                  ? "rotate-90 text-mk-primary"
                  : "text-mk-primary-bright group-hover:text-white"
              }`}
              onMouseEnter={() => {
                props.handleEnableDrag(false);
              }}
              onClick={() => {
                setOpenSection(!openSection);
              }}
            />
          </Whisper>
        </div>
      </div>

      <div
        className={` p-5 hover:cursor-default  outlineCardHeightView rounded-xl overflow-x-auto scroll-smooth 
                    ${
                      openSection === true
                        ? "bg-mk-primary-15 p-5  flex flex-row space-x-3"
                        : "hidden"
                    }`}
      >
        {toggle
          ? chaptCards.questions?.map((ele, i) => {
              return (
                <ViewAssementCard
                  lastQuestion={
                    i === chaptCards.questions!!.length - 1 ? true : false
                  }
                  key={i}
                  question={ele}
                  showCardMenuBar={false}
                />
              );
            })
          : chaptCards.cards.map((ele, i) => {
              return (
                <CardComponent
                  enableDrag={false}
                  handleEnableDrag={(e: boolean) => {}}
                  handleDuplicateCard={(e: string) => {}}
                  index={(e: string) => i}
                  handleCardContentChange={(
                    cardId: string,
                    content?: string
                  ) => {}}
                  handleSpecificCardUpdate={(e: CourseModuleCards) => {}}
                  handleCardVideoUpdate={(cardId: string, videoUrl?: any) => {}}
                  handleGenVideoUrl={(cardId: string, url: any) => {}}
                  handleGenImageUrl={(cardId: string, url: any) => {}}
                  handleCardAudioUpdate={(cardId: string, audioUrl?: any) => {}}
                  removeCard={(e: string) => {}}
                  maxCards={chaptCards.cards.length}
                  cardType={chaptCards.cards[i].cardType}
                  showCardOptions={false}
                  key={ele.cardId}
                  dataItem={ele}
                  isDisabled={false}
                  isActive={false}
                  isDragged={false}
                  isDragCue={false}
                  style={{}}
                  cards={props.cards}
                  //  videoGeneratingCardIds={null}
                  videoGeneratingCardIds={new Set()}
                />
              );
            })}
      </div>
    </div>
  );
}
